function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import isObject from "../core/helpers/isObject";
import { marginLeft, marginTop } from "../core/enhancers";
// Селектор для отступ для непервого чилдрена
var selector = "& > * + *"; // Хелпер для выбора нужного энхенсера и имени css св-ва

var getMargin = {
  row: {
    enhancer: marginLeft,
    name: "marginLeft"
  },
  column: {
    enhancer: marginTop,
    name: "marginTop"
  }
}; // Хелпер создания стилей для direction c простыми значениями:

var createCssForDirection = function createCssForDirection(_ref) {
  var theme = _ref.theme,
      direction = _ref.direction,
      gap = _ref.gap;
  return _defineProperty({
    flexDirection: direction
  }, selector, getMargin[direction].enhancer(_defineProperty({
    theme: theme
  }, getMargin[direction].name, gap)));
};
/**
 * Энхенсер для генерации CSSObject, а именно отступа для чилдрена внутри Space.
 * В зависимости от значения direction устанавливает  marginLeft | marginTop чилдрену *
 * Необходим, когда direction используется с брейкпоинтами
 */


export var spaceEnhancer = function spaceEnhancer(_ref3) {
  var theme = _ref3.theme,
      gap = _ref3.gap,
      direction = _ref3.direction;

  if (!gap) {
    return {};
  }

  var breakpoints = theme.breakpoints,
      simpleBreakpointsOrder = theme.simpleBreakpointsOrder,
      _theme$breakpointsHel = theme.breakpointsHelpers,
      isSimpleBreakpoint = _theme$breakpointsHel.isSimpleBreakpoint,
      isComplexBreakpoint = _theme$breakpointsHel.isComplexBreakpoint,
      between = _theme$breakpointsHel.between,
      up = _theme$breakpointsHel.up;

  if (isObject(direction)) {
    var _Object$entries$reduc = Object.entries(direction).reduce(function (accumulator, breakpointWithValue) {
      var _breakpointWithValue = _slicedToArray(breakpointWithValue, 1),
          breakpointKey = _breakpointWithValue[0];

      if (isSimpleBreakpoint(breakpointKey)) {
        accumulator.mediaQueries.push(breakpointWithValue);
      }

      if (isComplexBreakpoint(breakpointKey)) {
        accumulator.customMediaQueries.push(breakpointWithValue);
      }

      return accumulator;
    }, {
      mediaQueries: [],
      customMediaQueries: []
    }),
        mediaQueries = _Object$entries$reduc.mediaQueries,
        customMediaQueries = _Object$entries$reduc.customMediaQueries;

    mediaQueries.sort(function (_ref4, _ref5) {
      var _ref6 = _slicedToArray(_ref4, 1),
          a = _ref6[0];

      var _ref7 = _slicedToArray(_ref5, 1),
          b = _ref7[0];

      return simpleBreakpointsOrder.indexOf(a) > simpleBreakpointsOrder.indexOf(b) ? 1 : -1;
    }); // Создаем объект с медиа-выражениями для кастомных брейкпоинтов

    var resultWithMediaQueries = customMediaQueries.reduce(function (accumulator, _ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
          breakpointKey = _ref9[0],
          directionValue = _ref9[1];

      return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, breakpoints[breakpointKey], createCssForDirection({
        theme: theme,
        direction: directionValue,
        gap: gap
      })));
    }, {}); // Добавляем обычные брейкпоинты

    resultWithMediaQueries = mediaQueries.reduce(function (accumulator, _ref10) {
      var _ref11 = _slicedToArray(_ref10, 2),
          breakpointKey = _ref11[0],
          directionValue = _ref11[1];

      var nextBreakpoint = simpleBreakpointsOrder[simpleBreakpointsOrder.indexOf(breakpointKey) + 1]; // Есть ли следующий брейкпоинт в пропсах, чтоб потом использовать ф-ю between, либо up

      var hasPropsNextBp = nextBreakpoint ? Boolean(mediaQueries.find(function (_ref12) {
        var _ref13 = _slicedToArray(_ref12, 1),
            breakpointKeyToFind = _ref13[0];

        return breakpointKeyToFind === nextBreakpoint;
      })) : false; // Медиа-выражение для текущего брейкпоинта

      var currentMq = hasPropsNextBp ? between(breakpointKey, nextBreakpoint) : up(breakpointKey);
      return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, currentMq, createCssForDirection({
        theme: theme,
        direction: directionValue,
        gap: gap
      })));
    }, resultWithMediaQueries);
    return resultWithMediaQueries;
  }

  return createCssForDirection({
    theme: theme,
    direction: direction,
    gap: gap
  });
};